import ThemeSelection from 'components/GlobalModals/AddGiftMessageModal/ThemeSelection/ThemeSelection';
const ConnectedThemeSelection = ThemeSelection;

export default ConnectedThemeSelection;
